import { createStack } from 'hub-http';
import promiseClient from 'hub-http/adapters/promiseClient';
import hubapiStack from 'hub-http/stacks/hubapi';
import * as core from 'hub-http/middlewares/core';
export const retryerClient = promiseClient(createStack(core.retry(response => response.status === 0 || response.status >= 500, {
  maxRetries: 10
}), hubapiStack));